import { useState } from 'react'

import { useMeQuery } from '@/src/features/auth/services/useMeQuery'

import { getIsLoggedIn } from '../../auth/utils/getIsLoggedIn'
import { useRandomPopularUnprayedIntentionsQuery } from '../../intention/services/useRandomPopularUnprayedIntentionsQuery'

type TElementToDisplay = 'intention-form' | 'random-intention' | 'nothing'

export const usePublicationRewardSection = (
  communityId: number,
  publicationId: number,
): { elementToDisplay: TElementToDisplay; isLoading: boolean } => {
  const [elementToDisplay, setElementToDisplay] = useState<TElementToDisplay>('nothing')
  const [roll] = useState(() => Math.random())
  const me = useMeQuery()
  const { intention, isLoading: randomLoading } = useRandomPopularUnprayedIntentionsQuery(communityId, publicationId)

  const isLoading = me.isLoading || randomLoading
  const isIntentionAvailable = !!intention
  const hasIntention = !!me.data?.intention
  const isLoggedIn = getIsLoggedIn()
  /** Users cannot post an intention if they are not logged in or if they already have an intention */
  const isAllowedToPostIntention = !hasIntention && isLoggedIn

  if (!isLoading && elementToDisplay === 'nothing') {
    let next: TElementToDisplay = 'nothing'
    if (isIntentionAvailable) {
      const isOnceInFiveTimes = roll < 1 / 5
      next = isAllowedToPostIntention && isOnceInFiveTimes ? 'intention-form' : 'random-intention'
    } else if (isAllowedToPostIntention) {
      next = 'intention-form'
    }

    if (next !== 'nothing') {
      setElementToDisplay(next)
    }
  }

  return { elementToDisplay, isLoading: me.isLoading || isLoading }
}
